import { Controller } from "@hotwired/stimulus";

// Blocking terms modal: locks scroll and cannot be dismissed without accepting.
export default class extends Controller {
  connect() {
    document.body.style.overflow = "hidden";
  }

  disconnect() {
    document.body.style.overflow = "";
  }

  stopPropagation(event) {
    event.stopPropagation();
  }
}
